export const BATCH_UPLOAD_TEMPLATE_URL = 'https://server-resource-v4.cheweijia.com/public/assets/templates/jaguar/%E6%89%B9%E9%87%8F%E6%B7%BB%E5%8A%A0%E7%BB%AD%E7%BA%A6%E8%BD%A6%E8%BE%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
